import { render } from "./ui-sweetalerts.vue?vue&type=template&id=067a7c11"
import script from "./ui-sweetalerts.vue?vue&type=script&lang=js"
export * from "./ui-sweetalerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__